import type { SettingSectionLayout } from '../settingLayout';

/** The "Invoice creation and lines" section: its group bands and their rows, in page order. */
export const INVOICE_CREATION_SECTION: SettingSectionLayout = {
    anchor: 'invoice-creation',
    groups: [],
};
